/* Identical file in Marketing & NL-CMS. If you modify this file, make the same changes there,
and vice-versa, unless changes should be specific to this project, then remove this comment. */
import clsx from 'clsx';
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';

import FieldError from './FieldError';
import FieldLabel from './FieldLabel';

interface TextAreaFieldProps {
  autoComplete?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
  hint?: string;
  label?: string;
  maxCharCount?: number;
  minRows?: number;
  name: string;
  placeholder?: string;
  rows?: number;
}

const TextAreaField = (props: TextAreaFieldProps) => {
  const { label, name, hint } = props;
  const { maxCharCount, className, inputClassName, ...inputProps } = props;
  const [field, meta] = useField(name);
  const [charCount, setCharCount] = useState(field.value?.length || 0);

  useEffect(() => {
    if (maxCharCount) {
      setCharCount(field.value?.length || 0);
    }
  }, [field.value, maxCharCount]);

  return (
    <div className={className}>
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
      {hint && (
        <div className="mb-8 font-suisse-intl text-button-sm text-primary-black">{hint}</div>
      )}
      <textarea
        className={clsx(
          inputClassName,
          'block min-h-[75px] w-full resize-y rounded-0 border-grayscale-beige px-8 py-16 font-suisse-intl text-button-sm text-primary-black outline-none dark:bg-[var(--light-grayscale-charcoal)]'
        )}
        id={name}
        {...inputProps}
        {...field}
      />
      {maxCharCount && (
        <div
          className={clsx('font-suisse-screen text-disclosure-sm text-grayscale-gray', {
            'text-primary-magenta': meta.touched && meta.error,
          })}
        >
          ({charCount}/{maxCharCount})
        </div>
      )}
      {meta.touched && meta.error && <FieldError>{meta.error}</FieldError>}
    </div>
  );
};

export default TextAreaField;
